var map = {
	"./cn/北京中加学校/pc.svg": "Ri8l",
	"./en/北京中加学校/pc.svg": "6kRz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JUXY";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/北京中加学校\/pc\.svg$
// module id = JUXY
// module chunks = 16